export default {
  creditWallet: "Credit Wallet",
  creditLimit: "Credit Limit",
  usedCredit: "Used Credit",
  available: "Available",
  creditDays: "Credit Days",
  creditUsage: "Credit Usage",
  outstandingOrders: "Outstanding Orders",
  paymentHistory: "Payment History",
  order: "Order",
  total: "Total",
  due: "Due",
  dueDate: "Due Date",
  status: "Status",
  settlementId: "Settlement ID",
  ordersPaid: "Orders Paid",
  amount: "Amount",
  mode: "Mode",
  date: "Date",
  receipt: "Receipt",
  view: "View",
  pdf: "PDF",
  close: "Close",
  reset: "Reset",
  rotate: "Rotate",
  download: "Download",
  paid: "PAID",
unpaid: "UNPAID",
partial: "PARTIAL",
overdue: "OVERDUE",
cash: "Cash",
card: "Card",
bank: "Bank",
online: "Online",
receiptPreview: "Receipt Preview",
receiptNotAvailable: "Receipt not available",
unableDownloadPdf: "Unable to download PDF",
// GRN List

  resgoods_receipt_notes: "Goods Receipt Notes",
  resgrn_no: "GRN No",
  resorder: "Order",
  resno_grns_found: "No GRNs found",
  searchOrder:"Search Order",
};